
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./settings.resolver.cjs.production.min.js')
} else {
  module.exports = require('./settings.resolver.cjs.development.js')
}
